import { Home, Users, Package, Calendar, Settings, Box, ShoppingCart, Bell, Clock, Printer, BarChart3, UserCheck, FileSpreadsheet, CreditCard, UserX, Shield, ArrowRightLeft, QrCode, User, LifeBuoy, FileText } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { usePlatformAdmin } from '@/hooks/use-platform-admin';
import { useAuth } from '@/hooks/use-auth';

const baseNavItems = [
  { to: '/', icon: Home, label: 'Ana Sayfa' },
  { to: '/visits', icon: UserCheck, label: 'Ziyaretler' },
  { to: '/customers', icon: Users, label: 'Müşteriler' },
  { to: '/packages', icon: Package, label: 'Paketler' },
  { to: '/products', icon: Box, label: 'Ürünler' },
  { to: '/bayi-trades', icon: ArrowRightLeft, label: 'Bayi Ticareti' },
  { to: '/neodeyecegim', icon: CreditCard, label: 'Ne Ödeyeceğim?' },
  { to: '/eirsaliye', icon: FileText, label: 'e-Irsaliye' },
  { to: '/sales', icon: ShoppingCart, label: 'Satışlar' },
  { to: '/collections', icon: CreditCard, label: 'Tahsilatlar' },
  { to: '/onhold-sale', icon: Clock, label: 'Beklemedeki Satışlar' },
  { to: '/stock-entry', icon: Package, label: 'Stok Girişi' },
  { to: '/inventory-snapshots', icon: FileSpreadsheet, label: 'Stok Snapshot' },
  { to: '/unmatched', icon: Users, label: 'Eşleşmemiş' },
  { to: '/unknown-customers', icon: UserX, label: 'Bilinmeyen Müşteriler' },
  { to: '/qr-print', icon: Printer, label: 'QR Etiket' },
  { to: '/reports', icon: BarChart3, label: 'Raporlar' },
  { to: '/calendar', icon: Calendar, label: 'Takvim' },
  { to: '/notifications', icon: Bell, label: 'Bildirimler' },
  { to: '/destek', icon: LifeBuoy, label: 'Destek' },
  { to: '/settings', icon: Settings, label: 'Ayarlar' },
];

export const MobileNav = () => {
  const { isPlatformAdmin, loading: adminLoading } = usePlatformAdmin();
  const { userRole } = useAuth();
  const canSeeKnownCustomers = isPlatformAdmin || userRole === 'admin' || userRole === 'employee';
  const navItems = canSeeKnownCustomers
    ? [
        ...baseNavItems.slice(0, 14),
        { to: '/known-customers', icon: User, label: 'Tanınan Müşteriler' },
        ...baseNavItems.slice(14),
      ]
    : baseNavItems;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-panel-strong border-t border-white/20 md:hidden safe-bottom">
      <div className="flex items-center gap-1 py-2 px-2 overflow-x-auto scrollbar-hide">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 p-2 min-h-[60px] min-w-[70px] rounded-xl transition-all duration-200 no-zoom touch-target flex-shrink-0',
                'text-center',
                isActive
                  ? 'text-accent bg-accent/10 scale-105'
                  : 'text-foreground/70 hover:text-foreground hover:bg-white/5'
              )
            }
          >
            <item.icon className="w-5 h-5 flex-shrink-0" />
            <span className="text-xs font-medium leading-tight truncate w-full px-1">{item.label}</span>
          </NavLink>
        ))}
        
        {/* Platform Admin Link - Only visible to platform admins */}
        {!adminLoading && isPlatformAdmin && (
          <NavLink
            to="/admin"
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-1 p-2 min-h-[60px] min-w-[70px] rounded-xl transition-all duration-200 no-zoom touch-target flex-shrink-0',
                'text-center text-yellow-500',
                isActive
                  ? 'bg-yellow-500/20 text-yellow-400 scale-105'
                  : 'text-yellow-500/70 hover:text-yellow-400 hover:bg-yellow-500/10'
              )
            }
          >
            <Shield className="w-5 h-5 flex-shrink-0" />
            <span className="text-xs font-medium leading-tight truncate w-full px-1">Platform Admin</span>
          </NavLink>
        )}
        
        {/* QR Scan Button */}
        <NavLink
          to="/qr-scan"
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center gap-1 p-2 min-h-[60px] min-w-[70px] rounded-xl transition-all duration-200 no-zoom touch-target flex-shrink-0',
              'text-center',
              isActive
                ? 'text-accent bg-accent/10 scale-105'
                : 'text-foreground/70 hover:text-foreground hover:bg-white/5'
            )
          }
        >
          <QrCode className="w-5 h-5 flex-shrink-0" />
          <span className="text-xs font-medium leading-tight truncate w-full px-1">QR Tarama</span>
        </NavLink>
      </div>
    </nav>
  );
};